import React, { createContext, useContext, useEffect, useCallback } from 'react';
import useWebSocket from '../hooks/useWebSocket';
import soundGenerator from '../utils/soundGenerator';

const WebSocketContext = createContext();

export const useWebSocketContext = () => {
  const context = useContext(WebSocketContext);
  if (!context) {
    throw new Error('useWebSocketContext must be used within a WebSocketProvider');
  }
  return context;
};

export const WebSocketProvider = ({ children, userData, token }) => {
  const userId = userData?._id;

  const handleWebSocketMessage = useCallback((data) => {
    //Console.log('🔔 WebSocket message received:', data);
    
    if (data.type === 'new_notification') {
      // Play sound
      if (data.soundType) {
        soundGenerator.playNotificationSound(data.soundType);
      }
      
      // Show desktop notification if permission granted
      if (Notification.permission === 'granted' && data.notification) {
        new Notification(data.notification.title, {
          body: data.notification.message,
          icon: '/favicon.ico',
          tag: 'l2s-notification'
        });
      }
      
      // Dispatch event for other components
      window.dispatchEvent(new CustomEvent('new_notification', { 
        detail: data 
      }));
    }
  }, []);

  const { isConnected, reconnectAttempts, sendMessage } = useWebSocket(
    userId, 
    token, 
    handleWebSocketMessage
  );

  const value = {
    isConnected,
    reconnectAttempts,
    sendMessage,
    userId
  };

  return (
    <WebSocketContext.Provider value={value}>
      {children}
      
      {/* Connection Status Indicator
      <div style={{
        position: 'fixed',
        bottom: 10,
        right: 10,
        padding: '5px 10px',
        borderRadius: '15px',
        fontSize: '12px',
        backgroundColor: isConnected ? '#4CAF50' : '#f44336',
        color: 'white',
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        gap: '5px',
        opacity: 0.9,
        border: '1px solid white'
      }}>
        <div style={{
          width: '8px',
          height: '8px',
          borderRadius: '50%',
          backgroundColor: 'white',
          animation: isConnected ? 'pulse 2s infinite' : 'none'
        }}></div>
        {isConnected ? 'Live' : 'Offline'}
        {reconnectAttempts > 0 && ` (Retry ${reconnectAttempts})`}
      </div> */}
    </WebSocketContext.Provider>
  );
};